<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
    <Tab v-show="!$route.meta.fullScreen"/>
  </div>
</template>
<script>
import Tab from "./components/Tab";
export default {
  components: {
    Tab
  },
  data() {
    return {};
  },
  mounted() {},
  watch: {
    $route() {
      if (window._czc) {
        let location = window.location;
        let contentUrl = location.pathname + location.hash;
        let refererUrl = "/";
        window._czc.push(["_trackPageview", contentUrl, refererUrl]);
      }
    }
  },
};
</script>

<style>
body {
  font-size: 16px;
  background-color: #f8f8f8;
  -webkit-font-smoothing: antialiased;
  font-family: Helvetica;
}
.H {
  color: #ff0000;
}
</style>